<template>
  <div>
    <div class="bodyContainer" style="display: flex; flex-direction: column; gap: 20px; padding: 20px 0;">
      <el-card shadow="always" style="border-radius: 16px; border: none; padding: 10px;">
        <div style="background-color: #ecf5ff; border-left: 4px solid #409eff; color: #606266; padding: 12px 16px; border-radius: 4px; margin-bottom: 15px; font-size: 14px; line-height: 1.5; display: flex; align-items: flex-start;">
          <i class="el-icon-info" style="color: #409eff; margin-right: 10px; font-size: 18px; margin-top: 1px;"></i>
          <div>
            Please select the corresponding species and genes from the <strong>"Genes"</strong> page to generate a heatmap.
          </div>
        </div>
        <div style="background-color: #f0f9eb; border-left: 4px solid #67c23a; color: #606266; padding: 12px 16px; border-radius: 4px; margin-bottom: 20px; font-size: 14px; line-height: 1.5; display: flex; align-items: flex-start;">
          <i class="el-icon-info" style="color: #67c23a; margin-right: 10px; font-size: 18px; margin-top: 1px;"></i>
          <div>
            Click <strong>"Download heatmap data"</strong> to download example data, and use it as a template to create your own dataset for heatmap generation.
          </div>
        </div>
        <div class="upload">
          <el-upload
            class="upload-demo"
            ref="upload"
            action="#"
            :http-request="uploadFile"
            :on-change="handleChange"
            :file-list="fileList"
            :limit="1"
            :on-exceed="handleExceed"
            accept=".csv"
          >
            <el-button slot="trigger" size="small" type="primary" plain>
              Upload heatmap data
            </el-button>
            <div v-if="!show" style="display: inline-block;">
              <el-button
                style="margin-left: 10px"
                size="small"
                type="success"
                @click="submitUpload"
                plain
              >
                Draw heatmap
              </el-button>
            </div>
            <div v-if="show" style="display: inline-block;">
              <el-button
                style="margin-left: 10px"
                size="small"
                type="success"
                @click="submitUpload"
                plain
              >
                Clear
              </el-button>
            </div>
          </el-upload>
        </div>
        <div v-if="!show" class="sample-data">
        <!-- <div class="title">Sample Data :</div>
        <div>
          <a href="/example_data/heatmap.csv" download="heatmap.csv" type="primary">heatmap.csv</a>
        </div> -->


        <!-- <div class="title">Sample image :</div>
        <div class="heatmap-image">
          <el-image style="width: 1000px;" :src="imgUrl"></el-image>
        </div> -->
        </div>
      </el-card>

      <el-card v-if="show" shadow="always" style="border-radius: 16px; border: none; padding: 10px;">
        <div style="width: 100%; display: flex; justify-content: center;">
          <Heatmap
            :initialNames="names"
            :initialGenes="genes"
            :initialData="data"
            :initialSpecies="species"
          />
        </div>
      </el-card>
    </div>

    </div>
</template>
  <script>
import Heatmap from "../components/Heatmap.vue";
import Papa from "papaparse";
import { ref } from "vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "HeatMapTool",
  components: { Heatmap },
  data() {
    return {
      fileList: [],
      species: [],
      names: [],
      genes: [],
      data: [],
      show: false,
      imgUrl: ref(require("../images/heatmapDefault.png")),
    };
  },
  mounted() {
    const csvData = sessionStorage.getItem("heatMapCsvData");
    if (csvData) {
      sessionStorage.removeItem("heatMapCsvData");
      this.loadFromCsvString(csvData);
    } else {
      // 在组件挂载后自动执行上传和绘制
      this.autoUploadAndDraw();
    }
  },
  methods: {
    loadFromCsvString(csvData) {
      const fileBlob = new Blob([csvData], { type: 'text/csv' });
      const fileName = 'heatmap_data.csv';
      const file = new File([fileBlob], fileName, { type: 'text/csv' });
      const uploadFileObj = {
        file: file,
        name: fileName,
        size: file.size,
        type: file.type
      };
      
      this.uploadFile(uploadFileObj);
      this.fileList = [uploadFileObj];
      this.autoProcessed = true;
      setTimeout(() => {
        if (!this.show) {
          this.submitUpload();
        }
      }, 500);
    },
    // 自动上传和绘制热图的方法
    async autoUploadAndDraw() {
      try {
        // 获取示例文件路径
        const sampleFileUrl = '/example_data/heatmap.csv';
        
        // 获取示例文件
        const response = await fetch(sampleFileUrl);
        if (!response.ok) {
          throw new Error('Failed to fetch sample file');
        }
        
        const fileBlob = await response.blob();
        const fileName = 'heatmap.csv';
        
        // 创建文件对象
        const file = new File([fileBlob], fileName, { type: 'text/csv' });
        
        // 模拟上传文件
        const uploadFileObj = {
          file: file,
          name: fileName,
          size: file.size,
          type: file.type
        };
        
        // 调用上传方法
        this.uploadFile(uploadFileObj);
        
        // 将文件添加到文件列表
        this.fileList = [uploadFileObj];
        
        // 设置标志防止重复处理
        this.autoProcessed = true;
        
        // 延迟执行提交，确保数据解析完成
        setTimeout(() => {
          this.submitUpload();
        }, 500);
        
      } catch (error) {
        console.error('Auto upload failed:', error);
        this.$message.error('自动加载示例数据失败，请手动上传文件');
      }
    },
    
    uploadFile(file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const csvData = event.target.result;
        Papa.parse(csvData, {
          header: false,
          dynamicTyping: true,
          complete: (results) => {
            this.names = [];
            this.genes = [];
            this.species = [];
            this.data = [];
            this.names = results.data[0].filter(
              (item) => item !== "Species" && item !== ""
            );
            for (let i = 1; i < results.data.length; i++) {
              this.genes.push(results.data[i][0]);
            }
            for (let i = 1; i < results.data.length; i++) {
              for (let j = 1; j < results.data[i].length; j++) {
                this.data.push([i - 1, j - 1, results.data[i][j]]);
              }
            }
          },
        });
      };
      reader.readAsText(file.file);
    },
    handleChange(file, fileList) {
        this.fileList = fileList;

    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `You can only upload 1 file. You have selected ${
          files.length
        } files, and a total of ${
          files.length + fileList.length
        } files have been selected.`
      );
    },
    submitUpload() {
      if (this.fileList.length == 0) {
        this.$message.warning(`You need to upload at least 1 file.`);
      } else {
        if (this.show) {
          this.show = false;
          this.fileList = [];
          // 绘制默认图表
          // this.autoUploadAndDraw();

        } else {
          this.show = true;
        }
      }
    },
  },
};
</script>
  <style scoped>
.upload-demo .el-upload {
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.upload-demo {
  display: flex;
  width: 1300px;
  margin: auto;
}
.upload {
  display: flex;
  margin: 10px;
}
div.el-upload__tip {
  margin-bottom: 10px;
}
div.heatmap-image {
  text-align: center;
}
.el-image {
  margin: 10px;
}
.bodyContainer {
  width: 1300px;
  margin: auto;
}
.title{
  font-size: 20px;
  /* margin-top: 10px; */
}
</style>